import { all } from 'redux-saga/effects';

import { watchDeleteDocument, watchGetDocumentInfo, watchGetDocumentList } from './documents';

export default function* rootSagas() {
    yield all([watchGetDocumentList(), watchGetDocumentInfo(), watchDeleteDocument()]);
}
